import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    style: _normalizeStyle({ 'font-size': _ctx.fontSize }),
    class: _normalizeClass(_ctx.className)
  }, null, 6))
}